import { render, staticRenderFns } from "./entityForm.vue?vue&type=template&id=e5679150&scoped=true&"
import script from "./entityForm.vue?vue&type=script&lang=ts&"
export * from "./entityForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5679150",
  null
  
)

export default component.exports